module.exports = __webpack_public_path__ + "img/pause-icon.9164fe2c.svg";